export { ReactComponent as ElementText } from './svgs/element-text.svg';
